import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from 'react';

var firstOne = function firstOne(s) {
  return (s || '').charAt(0).toUpperCase();
};

export default function useHumanInitials() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      name = _ref.name;

  return useMemo(function () {
    var _replace$split = (name || '').replace(/[,'"`]+/, '').split(' '),
        _replace$split2 = _slicedToArray(_replace$split, 2),
        nameLn = _replace$split2[0],
        nameFn = _replace$split2[1];

    return "".concat(firstOne(firstName || nameFn)).concat(firstOne(lastName || nameLn));
  }, [firstName, lastName, name]);
}